/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WheelSegment } from './WheelSegment';
import {
    WheelSegmentFromJSON,
    WheelSegmentFromJSONTyped,
    WheelSegmentToJSON,
} from './WheelSegment';

/**
 * 
 * @export
 * @interface WheelDetails
 */
export interface WheelDetails {
    /**
     * The wheel segments to display for this spin, including the winning prize. This array will always have the winning
     * item as the first element and some number of other non-winning items configured for the same category wheel to be
     * displayed alongside the other items in the spin animation. All the returned wheel segments will be unique with
     * no repeats, though the animation may choose to repeat elements given here.
     * @type {Array<WheelSegment>}
     * @memberof WheelDetails
     */
    segments: Array<WheelSegment>;
    /**
     * Promo text to show as a header or footer for a wheel.  This contains information such as the grand prize, possible prizes, etc.
     * @type {Array<string>}
     * @memberof WheelDetails
     */
    promoText: Array<string>;
    /**
     * The name of the category wheel segment this spin is for. This will determine what category is selected in the
     * category wheel spin, and what items appear in the wheelSegments array. This will be null/undefined unless a spin
     * has the COMPLETE status.
     * @type {string}
     * @memberof WheelDetails
     */
    name: string;
}

/**
 * Check if a given object implements the WheelDetails interface.
 */
export function instanceOfWheelDetails(value: object): value is WheelDetails {
    if (!('segments' in value) || value['segments'] === undefined) return false;
    if (!('promoText' in value) || value['promoText'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function WheelDetailsFromJSON(json: any): WheelDetails {
    return WheelDetailsFromJSONTyped(json, false);
}

export function WheelDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WheelDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'segments': ((json['segments'] as Array<any>).map(WheelSegmentFromJSON)),
        'promoText': json['promoText'],
        'name': json['name'],
    };
}

export function WheelDetailsToJSON(value?: WheelDetails | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'segments': ((value['segments'] as Array<any>).map(WheelSegmentToJSON)),
        'promoText': value['promoText'],
        'name': value['name'],
    };
}

